import { Box, Button, Flex } from '@chakra-ui/react';

import { Dialog, Txt } from '@app/components/common';

export const Confirm = ({
  open,
  onClose,
  onConfirm,
}: {
  open: boolean;
  onClose(): void;
  onConfirm(): void;
}) => {
  return <Dialog 
    title="Подтверждение" 
    open={open} 
    onClose={onClose}
    actions={<Flex justifyContent="space-between" flex={1}>
      <Button colorScheme='brand' onClick={onConfirm}>Подтвердить</Button>
      <Button variant='ghost' onClick={onClose}>Отмена</Button>
    </Flex>}
  >
    <Box  display='flex' flexDirection='column'>
      <Txt>Вы уверены, что хотите продолжить?</Txt>
    </Box>
    
  </Dialog>;
};